import { useState, useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import DownloadModalTables from "../../components/DownloadModalTables";
import NavigationPanelLawyer from "../../components/NavigationPanelLawyer";
import DebtCollectionNav from "../../components/DebtCollectionNav";
import PortalPopup from "../../components/PortalPopup";
import CourtStatusFilter from "../../components/CourtStatusFilter";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import Breadcrumb from "../../components/Breadcrumb";
import { Judge, MoneyRecive, TickCircle } from "iconsax-reactjs";
import CTAs from "../../components/CTAs";
import TabState from "../../components/TabState";
import Footer from "../../components/Footer";

const Legal_proceedings_1 = () => {
  const navigate = useNavigate();
  const [isDownloadModalTablesOpen, setDownloadModalTablesOpen] =
    useState(false);
  const [isCourtStatusFilterOpen, setCourtStatusFilterOpen] = useState(false);
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);

  const openDownloadModalTables = useCallback(() => {
    setDownloadModalTablesOpen(true);
  }, []);

  const closeDownloadModalTables = useCallback(() => {
    setDownloadModalTablesOpen(false);
  }, []);

  const openCourtStatusFilter = useCallback(() => {
    setCourtStatusFilterOpen(true);
  }, []);

  const closeCourtStatusFilter = useCallback(() => {
    setCourtStatusFilterOpen(false);
  }, []);

  const onClickBillingSchedule = useCallback(() => {
    navigate("/legal_2");
  }, [navigate]);

  const onClickReportAndAnalytics = useCallback(() => {
    navigate("/legal_3");
  }, [navigate]);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  const navItems = [
    {
      text: "Dashboard",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/dashboard",
    },
    {
      text: "Legal proceedings & billing",
      bgColor: "bg-primary-primary-50",
      textColor: "text-neutrals-neutral-900",
      hoverBgColor: "bg-primary-primary-50",
      hoverTextColor: "text-neutrals-neutral-900",
      path: "",
    },
    {
      text: "Pre-LBA checks",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/prelbacheck",
    },
    {
      text: "Client-debtor interaction",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/cdi1",
    },
  ];

  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  const case_list = [
    {
      caseId: "1",
      name: "Paras Mistry",
      stage: "Stage 2",
      court_status: "In progress",
      billing_status: "Pending",
    },
    {
      caseId: "2",
      name: "Asha Gupta",
      stage: "Stage 2",
      court_status: "Completed",
      billing_status: "Paid",
    },
    {
      caseId: "3",
      name: "Liam Chen",
      stage: "Stage 2",
      court_status: "Awaiting action",
      billing_status: "Unpaid",
    },
    {
      caseId: "4",
      name: "Sofia Martinez",
      stage: "Stage 2",
      court_status: "Completed",
      billing_status: "Paid",
    },
    {
      caseId: "5",
      name: "Rajesh Kumar",
      stage: "Stage 2",
      court_status: "Completed",
      billing_status: "Paid",
    },
    {
      caseId: "6",
      name: "Emily Johnson",
      stage: "Stage 2",
      court_status: "Completed",
      billing_status: "Paid",
    },
    {
      caseId: "7",
      name: "Carlos Ramirez",
      stage: "Stage 2",
      court_status: "Completed",
      billing_status: "Pending",
    },
    {
      caseId: "8",
      name: "Maya Patel",
      stage: "Stage 2",
      court_status: "Completed",
      billing_status: "Pending",
    },
    {
      caseId: "9",
      name: "Santiago Rivera",
      stage: "Stage 2",
      court_status: "In progress",
      billing_status: "Paid",
    },
    {
      caseId: "10",
      name: "Nina Wong",
      stage: "Stage 2",
      court_status: "In progress",
      billing_status: "Paid",
    },
  ];

  const filteredDebtors =
    activeTab === "all"
      ? case_list
      : case_list.filter(
          (debtor) => debtor.status.toLowerCase() === activeTab.toLowerCase()
        );

  const searchedDebtors = filteredDebtors.filter(
    (debtor) =>
      debtor.caseId.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.stage.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.court_status.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.billing_status.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const courtStatusMap = {
    "In progress": "bg-white text-black border-gray-100",
    Completed: "bg-white text-black border-gray-100",
    "Awaiting action": "bg-white text-black border-gray-100",
  };

  const courtStatusIcon = {
    "In progress": <span style={{ color: "red" }}>•</span>,
    Completed: <span style={{ color: "blue" }}>•</span>,
    "Awaiting action": <span style={{ color: "orange" }}>•</span>,
  };

  const statusColorMap = {
    Unpaid: "bg-red-100 text-red-500 border-red-500",
    Pending: "bg-yellow-100 text-yellow-600 border-yellow-500",
    Paid: "bg-green-100 text-green-500 border-green-500",
  };

  const statusIconMap = {
    Unpaid: "•",
    Pending: "•",
    Paid: "•",
  };

  // For legal proceedings tabs
  const tabs = [
    { label: "Case overview", to: "/legal_1" },
    { label: "Billing schedule", to: "/legal_2" },
    { label: "Reports and analytics", to: "/legal_3" },
  ];

  return (
    <>
      <div className="w-full relative bg-neutrals-neutral-50 min-h-screen overflow-visible text-left text-sm text-neutrals-neutral-300 font-open-sans-ff-body-strong">
        {/* Navigation Panel */}
        <NavigationPanelLawyer navItems={navItems} />

        {/* Main */}
        <div className="w-full absolute top-[136px] flex flex-col items-start justify-start gap-6 text-9xl text-neutrals-neutral-900 px-4 md:px-4 lg:px-24 box-border">
          {/* Heading */}
          <div className="self-stretch bg-white border-neutrals-neutral-100 border-solid border-b-[1px] flex flex-col items-start justify-start pt-0 px-0 pb-6 gap-1.5">
            <b className="relative">Legal proceedings and billing</b>
            <div className="relative text-base text-neutrals-neutral-300">
              Get to know time remaining for your LBA
            </div>
          </div>

          {/* Tabs */}
          <div className="self-stretch flex flex-col items-start justify-start gap-8 text-base text-neutrals-neutral-300">
            <div className="self-stretch flex flex-col items-start justify-start gap-6">
              <div className="flex flex-row items-start justify-start gap-6">
                {tabs.map((tab) => (
                  <TabState key={tab.to} label={tab.label} to={tab.to} />
                ))}
              </div>
              <div className="self-stretch flex flex-col items-start justify-start gap-6">
                <div className="self-stretch flex flex-col md:flex-row lg:flex-row items-center justify-start content-center gap-6">
                  {/* Block 1 */}
                  <div className="w-full rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start">
                    <div className="self-stretch flex flex-row items-start justify-between p-6 gap-0">
                      <div className="flex flex-col items-start justify-start gap-[24px]">
                        <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-start justify-start p-2.5 border-[1px] border-solid border-neutrals-neutral-100">
                          <TickCircle size={20} color="#2D404E" />
                        </div>
                        <div className="flex flex-col items-start justify-start gap-[10px]">
                          <div className="relative">Total active cases</div>
                          <b className="relative text-13xl text-neutrals-neutral-900">
                            45
                          </b>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Block 2 */}
                  <div className="w-full rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start">
                    <div className="self-stretch flex flex-row items-start justify-between p-6 gap-0">
                      <div className="flex flex-col items-start justify-start gap-[24px]">
                        <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-start justify-start p-2.5 border-[1px] border-solid border-neutrals-neutral-100">
                          <Judge size={20} color="#2D404E" />
                        </div>
                        <div className="flex flex-col items-start justify-start gap-[10px]">
                          <div className="relative">Cases in court</div>
                          <b className="relative text-13xl text-neutrals-neutral-900">
                            15
                          </b>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Block 3 */}
                  <div className="w-full rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start">
                    <div className="self-stretch flex flex-row items-start justify-between p-6 gap-0">
                      <div className="flex flex-col items-start justify-start gap-[24px]">
                        <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-start justify-start p-2.5 border-[1px] border-solid border-neutrals-neutral-100">
                          <MoneyRecive size={20} color="#2D404E" />
                        </div>
                        <div className="flex flex-col items-start justify-start gap-[10px]">
                          <div className="relative">Total revenue</div>
                          <b className="relative text-13xl text-neutrals-neutral-900">
                            £200,000
                          </b>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Table */}
                <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs flex flex-col items-start justify-start text-sm text-neutrals-neutral-900">
                  <div className="w-full rounded-t-3xs rounded-b-none border-neutrals-neutral-100 border-solid border-t-[1px] border-r-[1px] border-l-[1px] box-border flex flex-row items-center justify-between py-5 px-6 gap-0 text-lg">
                    <div className="flex flex-row items-center justify-start gap-[10px]">
                      <div className="relative font-semibold">Case list</div>
                      <div className="rounded-8xs bg-neutrals-neutral-50 flex flex-row items-center justify-start py-0.5 px-2 gap-[6px] text-sm border-[1px] border-solid border-neutrals-neutral-100">
                        <div className="w-1.5 relative rounded-[50%] bg-primary-primary-500 h-1.5" />
                        <div className="relative font-semibold">10 cases</div>
                      </div>
                    </div>
                    <CTAs
                      type="Secondarybtn"
                      text="Download"
                      borderColor="border-neutrals-neutral-100"
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M9 11v6l2-2M9 17l-2-2"
                            stroke="#2d404e"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                          <path
                            d="M22 10v5c0 5-2 7-7 7H9c-5 0-7-2-7-7V9c0-5 2-7 7-7h5"
                            stroke="#2d404e"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                          <path
                            d="M22 10h-4c-3 0-4-1-4-4V2l8 8Z"
                            stroke="#2d404e"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      }
                      onClick={openDownloadModalTables}
                    />
                  </div>
                  {/* Filters and search bar */}
                  <div className="w-full box-border flex flex-row items-center justify-between py-3 px-6 border-t-[1px] border-solid border-neutrals-neutral-100 border-r-[1px] border-l-[1px]">
                    <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-start">
                      <div className="rounded-tl-3xs rounded-tr-none rounded-br-none rounded-bl-3xs bg-column-bg flex flex-row items-center justify-center py-2 px-4 border-[1px] border-solid border-neutrals-neutral-100">
                        <div className="relative font-semibold">View all</div>
                      </div>
                      <div className="flex flex-row items-center justify-center py-2 px-4 border-r-[1px] border-b-[1px] border-t-[1px] border-solid border-neutrals-neutral-100">
                        <div className="relative font-semibold">Paid</div>
                      </div>
                      <div className="flex flex-row items-center justify-center py-2 px-4 border-r-[1px] border-b-[1px] border-t-[1px] border-solid border-neutrals-neutral-100">
                        <div className="relative font-semibold">Pending</div>
                      </div>
                      <div className="rounded-tl-none rounded-tr-3xs rounded-br-3xs rounded-bl-none flex flex-row items-center justify-center py-2 px-4 border-t-[1px] border-solid border-neutrals-neutral-100 border-r-[1px] border-b-[1px]">
                        <div className="relative font-semibold">Unpaid</div>
                      </div>
                    </div>
                    {/* Search bar and filter cta */}
                    <div className="flex flex-row items-start justify-start gap-[10px] text-neutrals-neutral-300">
                      <div className="w-[294px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border flex flex-row items-center justify-start py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100">
                        <div className="flex flex-row items-center justify-start gap-[10px]">
                          <img
                            className="w-5 relative h-5"
                            alt=""
                            src="assets/search.svg"
                          />
                          <div className="relative">Search</div>
                        </div>
                      </div>
                      <div
                        className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-center py-2.5 px-3.5 cursor-pointer text-neutrals-neutral-900 border-[1px] border-solid border-neutrals-neutral-100"
                        onClick={openCourtStatusFilter}
                      >
                        <div className="flex flex-row items-center justify-center gap-[6px]">
                          <img
                            className="w-5 relative h-5"
                            alt=""
                            src="assets/filter.svg"
                          />
                          <div className="relative font-semibold">Filter</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Main content */}
                  <div className="w-full flex flex-col items-start justify-start">
                    <div className="w-full flex flex-col items-start justify-start">
                      <div className="w-full self-stretch flex flex-row items-start justify-start">
                        <table className="min-w-full divide-y divide-gray-200 border-collapse">
                          <thead className="bg-column-bg">
                            <tr>
                              <th
                                scope="col"
                                className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-l-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                              >
                                Case id
                              </th>
                              <th
                                scope="col"
                                className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                              >
                                Client name
                              </th>
                              <th
                                scope="col"
                                className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                              >
                                Current stage
                              </th>
                              <th
                                scope="col"
                                className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                              >
                                Court status
                              </th>
                              <th
                                scope="col"
                                className="items-start justify-start py-3 px-4 border-t-[1px] border-r-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                              >
                                Billing status
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-neutrals-neutral-50 divide-y divide-gray-200">
                            {searchedDebtors.map((case_list) => (
                              <tr key={case_list.id} className="hover:bg-gray">
                                <td className="p-4 items-start border-solid border-b-[1px] border-l-[1px] border-neutrals-neutral-100">
                                  {case_list.caseId}
                                </td>
                                <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                                  {case_list.name}
                                </td>
                                <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                                  {case_list.stage}
                                </td>
                                <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100 whitespace-nowrap">
                                  <span
                                    className={`px-2 py-0.5 text-xs font-semibold rounded-md border-solid border-[1px] border-neutrals-neutral-100 ${
                                      courtStatusMap[case_list.court_status]
                                    }`}
                                  >
                                    <span className="mr-1">
                                      {courtStatusIcon[case_list.court_status]}
                                    </span>
                                    {case_list.court_status}
                                  </span>
                                </td>
                                <td className="p-4 items-start border-solid border-b-[1px] border-r-[1px] border-neutrals-neutral-100 whitespace-nowrap">
                                  <span
                                    className={`px-2 py-0.5 text-xs font-semibold rounded-full border-solid border-[1px] ${
                                      statusColorMap[case_list.billing_status]
                                    }`}
                                  >
                                    <span className="mr-1">
                                      {statusIconMap[case_list.billing_status]}
                                    </span>
                                    {case_list.billing_status}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {/* Pagination */}
                  <div className="w-full rounded-t-none rounded-b-3xs box-border flex flex-row items-center justify-between pt-3 px-6 pb-4 border-r-[1px] border-solid border-neutrals-neutral-100 border-b-[1px] border-l-[1px]">
                    <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-center py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100">
                      <div className="flex flex-row items-center justify-center">
                        <div className="relative font-semibold">Previous</div>
                      </div>
                    </div>
                    <div className="relative">Page 1 of 10</div>
                    <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-center py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100">
                      <div className="flex flex-row items-center justify-center">
                        <div className="relative font-semibold">Next</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="self-stretch flex flex-col items-start justify-start gap-6 text-lg text-neutrals-neutral-900">
            <div className="self-stretch flex flex-col items-start justify-start gap-1.5">
              <div className="relative font-semibold">{`Document repository`}</div>
              <div className="relative text-sm text-neutrals-neutral-300">
                Get your history of actions over here.
              </div>
            </div>
            <div className="self-stretch flex flex-col items-start justify-start gap-6 text-sm text-neutrals-neutral-300">
              <div className="self-stretch flex flex-row items-center justify-between gap-0">
                <div className="w-[294px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-row items-center justify-start py-2.5 px-3.5">
                  <div className="flex flex-row items-center justify-start gap-2.5">
                    <img
                      className="w-5 relative h-5"
                      alt=""
                      src="assets/search.svg"
                    />
                    <div className="relative">Search your documents</div>
                  </div>
                </div>
                <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-center py-2.5 px-3.5 text-neutrals-neutral-900">
                  <div className="flex flex-row items-center justify-center gap-1.5">
                    <img
                      className="w-5 relative h-5"
                      alt=""
                      src="assets/filter.svg"
                    />
                    <div className="relative font-semibold">Filter</div>
                  </div>
                </div>
              </div>
              <div className="self-stretch flex flex-row items-start justify-start flex-wrap content-start gap-6 text-center text-neutrals-neutral-900">
                <div className="flex flex-col items-center justify-start gap-[6px]">
                  <img
                    className="w-10 relative h-10"
                    alt=""
                    src="assets/folder_close.svg"
                  />
                  <div className="relative font-semibold">
                    Court Submissions
                  </div>
                  <div className="relative text-base text-neutrals-neutral-300">
                    5 items
                  </div>
                </div>
                <div className="flex flex-col items-center justify-start gap-[6px]">
                  <img
                    className="w-10 relative h-10"
                    alt=""
                    src="assets/folder_close.svg"
                  />
                  <div className="relative font-semibold">Acknowledgments</div>
                  <div className="relative text-base text-neutrals-neutral-300">
                    2 items
                  </div>
                </div>
                <div className="flex flex-col items-center justify-start gap-[6px]">
                  <img
                    className="w-10 relative h-10"
                    alt=""
                    src="assets/folder_close.svg"
                  />
                  <div className="relative font-semibold">Legal documents</div>
                  <div className="relative text-base text-neutrals-neutral-300">
                    10 items
                  </div>
                </div>
                <div className="flex flex-col items-center justify-start">
                  <div className="flex flex-col items-center justify-start gap-[6px]">
                    <div className="flex flex-row items-start justify-start relative gap-[10px]">
                      <img
                        className="w-10 relative h-10 z-[0]"
                        alt=""
                        src="assets/word_file.svg"
                      />
                    </div>
                    <div className="relative font-semibold">
                      Legal_proceedings.docx
                    </div>
                    <div className="relative text-base text-neutrals-neutral-300">
                      24KB
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-center justify-start gap-[6px]">
                  <img
                    className="w-10 relative h-10"
                    alt=""
                    src="assets/pdf.svg"
                  />
                  <div className="flex flex-col items-center justify-start gap-[6px]">
                    <div className="relative font-semibold">Contract.pdf</div>
                    <div className="relative text-base text-neutrals-neutral-300">
                      2.6MB
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-center justify-start">
                  <div className="flex flex-col items-center justify-start gap-[6px]">
                    <img
                      className="w-10 relative h-10"
                      alt=""
                      src="assets/pdf.svg"
                    />
                    <div className="relative font-semibold">Defence_01.pdf</div>
                    <div className="relative text-base text-neutrals-neutral-300">
                      1.3MB
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>

      {isDownloadModalTablesOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeDownloadModalTables}
        >
          <DownloadModalTables onClose={closeDownloadModalTables} />
        </PortalPopup>
      )}
      {isCourtStatusFilterOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeCourtStatusFilter}
        >
          <CourtStatusFilter onClose={closeCourtStatusFilter} />
        </PortalPopup>
      )}
      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
    </>
  );
};

export default Legal_proceedings_1;
